export default __webpack_public_path__ + "static/media/down.f994f25f.svg";